export const portalAppsUrl = import.meta.env.VITE_PORTAL_URL || 'http://127.0.0.1:4173/apps';
